const formatRequestOptions = (data, method = 'GET', shouldUseTokenBearer = true) => {
  return ({
    method,
    headers: {
      ...(shouldUseTokenBearer ? { 'Content-Type': 'application/json' } : {}),
      Authorization: shouldUseTokenBearer && data?.token ? `Bearer ${data.token}` : {},
    },
    body: shouldUseTokenBearer ? JSON.stringify(data) : data || null,
  });
};

const returnFetchPromise = (url, data, method, shouldUseTokenBearer) => {
  const requestOptions = formatRequestOptions(data, method, shouldUseTokenBearer);
  return fetch(url, requestOptions);
};

export const capitalizeFirstLetter = (stringInput) => {
  return stringInput?.trim().replace(/^\w/, (c) => c.toUpperCase());
};

export const get = (url) => returnFetchPromise(url);
export const put = (url, data) => returnFetchPromise(url, data, 'PUT');
export const patch = (url, data) => returnFetchPromise(url, data, 'PATCH');
export const post = (url, data, shouldUseTokenBearer) => returnFetchPromise(url, data, 'POST', shouldUseTokenBearer);
export const destroy = (url, data) => returnFetchPromise(url, data, 'DELETE');
